import { SelectUniversal } from '@/modules/common/components/select-universal';
import styles from './index.module.sass';
import { Col, Modal, Row } from 'antd';
import { InputWithSignWheelControl } from '@/modules/common/components/input-with-sign-wheel';
import { ReactNode, useState } from 'react';
import {
  wheatSorts,
  wheatTypes,
} from '@/modules/common/constants/wheat-types.constatnt';
import classNames from 'classnames';
import { setWheatClassFormOrigin } from '@/modules/search/functions/set-wheat-class.function';
import { IWheatData } from '@/modules/search/ts/index.types';
import { useStore } from 'effector-react';
import { $agriculture } from '@/modules/agriculture/store/agriculture.store';
import { RangeSlider } from '../../../range-slider';
import { AGRICULTURES } from '@/modules/search/constants';
import { processNumberInput } from '@/modules/helpers/processNumberInput/processNumberInput';
import { EXTREME_INDICATORS } from '@/modules/mixing/constants/extreme-indicators.constants';

export const MidFiltersBar = ({
  state,
  setState,
  reIndicateClassAction,
  children,
  classesBarHidden,
  setRangesStateToDefault,
}: {
  state: IWheatData;
  setState: (val: IWheatData) => void;
  reIndicateClassAction: () => void;
  children?: ReactNode;
  classesBarHidden?: boolean;
  setRangesStateToDefault?: () => void;
}) => {
  const agricultures = useStore($agriculture);
  const wheat = agricultures.find((item) => item.name === AGRICULTURES[0].name);
  const wheatRanges = {
    gluten: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[0].name,
    ),
    humidity: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[1].name,
    ),
    idk: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[2].name,
    ),
    cp: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[3].name,
    ),
    protein: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[4].name,
    ),
    nature: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[5].name,
    ),
  };

  return (
    <div className={styles.root}>
      <span className={styles.title}>параметры зерновой культуры</span>
      <Row className={styles.row} gutter={16}>
        <Col span={9} className={styles.dropdown}>
          <span>сорт пшеницы</span>
          <SelectUniversal
            activeItem={wheatSorts.find((item) => item.value === state.sort)}
            onChange={(value: string) => {
              setState({ ...state, sort: value });
              reIndicateClassAction();
            }}
            options={wheatSorts}
            placeholder="сорт не выбран"
          />
        </Col>
        <Col span={9} className={styles.dropdown}>
          <span>тип пшеницы</span>
          <SelectUniversal
            activeItem={wheatTypes.find((item) => item.value === state.type)}
            onChange={(value: string) => {
              setState({ ...state, type: value });
              reIndicateClassAction();
            }}
            options={wheatTypes}
            placeholder="тип не указан"
          />
        </Col>
        <Col span={6} className={styles.divergence}>
          {!setRangesStateToDefault ? (
            <>
              <span className={styles.divergenceParam}>
                допустимое отклонение <br />
                min 0% - max 5%
              </span>
              <InputWithSignWheelControl
                float={true}
                min={0}
                max={5}
                value={String(state.divergence)}
                setValue={(val) =>
                  setState({ ...state, divergence: Number(val) > 5 ? 5 : Number(val) })
                }
                postfix={'%'}
                onChange={(e) => {
                  const value = e.target.value
                    .replace(/^0+/, '')
                    .replace(/[^0-5]/g, '');
                  const newValue = value.slice(-1);
                  setState({
                    ...state,
                    divergence:
                      parseInt(newValue) > 5 ? '5' : newValue === '' ? 0 : newValue,
                  });
                }}
              />
            </>
          ) : (
            <>
              <span
                className={styles.setDefault}
                onClick={() =>
                  Modal.confirm({
                    title: 'Подтвердите действие',
                    content:
                      'Вы уверены, что хотите сбросить значения диапазонов до начальных?',
                    okText: 'сбросить',
                    okButtonProps: { danger: true },
                    cancelText: 'назад',
                    onOk: () => setRangesStateToDefault(),
                  })
                }
              >
                сбросить значения диапазонов
              </span>
            </>
          )}
        </Col>
      </Row>
      {!classesBarHidden && (
        <Row>
          <Col span={24} className={styles.classes}>
            <div
              className={classNames(
                styles.classItem,
                state.class === 1 && styles.active,
              )}
              onClick={() => setWheatClassFormOrigin(1, state, setState)}
            >
              1й класс
            </div>
            <div
              className={classNames(
                styles.classItem,
                state.class === 2 && styles.active,
              )}
              onClick={() => setWheatClassFormOrigin(2, state, setState)}
            >
              2й класс
            </div>
            <div
              className={classNames(
                styles.classItem,
                state.class === 3 && styles.active,
              )}
              onClick={() => setWheatClassFormOrigin(3, state, setState)}
            >
              3й класс
            </div>
            <div
              className={classNames(
                styles.classItem,
                state.class === 4 && styles.active,
              )}
              onClick={() => setWheatClassFormOrigin(4, state, setState)}
            >
              4й класс
            </div>
            <div
              className={classNames(
                styles.classItem,
                state.class === 5 && styles.active,
              )}
              onClick={() => setWheatClassFormOrigin(5, state, setState)}
            >
              5й класс
            </div>
            {/* <div
            className={classNames(styles.classItem, state.class === 0 && styles.active)}
            onClick={() => setState({ ...state, class: 0 })}
          >
            класс не определен
          </div> */}
          </Col>
        </Row>
      )}
      {children ? (
        children
      ) : (
        <Row gutter={16} className={styles.span}>
          <Col span={6} className={styles.col}>
            <InputWithSignWheelControl
              label="год урожая"
              value={String(state.year)}
              onChange={(e) =>
                setState({
                  ...state,
                  year: +e.target.value.replaceAll(/[^0-9.]/g, ''),
                })
              }
              setValue={(val) => setState({ ...state, year: +val })}
              postfix={''}
            />
          </Col>
          <Col span={6} className={styles.col}>
            <InputWithSignWheelControl
              label="клейковина"
              float
              value={String(state.params.gluten)}
              min={EXTREME_INDICATORS.gluten.min}
              max={EXTREME_INDICATORS.gluten.max}
              onChange={(e) => {
                setState({
                  ...state,
                  params: {
                    ...state.params,
                    gluten: processNumberInput(e.target.value),
                  },
                });
                reIndicateClassAction();
              }}
              setValue={(val) => {
                setState({ ...state, params: { ...state.params, gluten: +val } });
                reIndicateClassAction();
              }}
              postfix={'%'}
              prefix={'≥'}
            />
          </Col>
          <Col span={6} className={styles.col}>
            <InputWithSignWheelControl
              label="ИДК"
              float
              value={String(state.params.idk)}
              min={EXTREME_INDICATORS.idk.min}
              max={EXTREME_INDICATORS.idk.max}
              onChange={(e) => {
                setState({
                  ...state,
                  params: {
                    ...state.params,
                    idk: processNumberInput(e.target.value),
                  },
                });
                reIndicateClassAction();
              }}
              setValue={(val) => {
                setState({ ...state, params: { ...state.params, idk: +val } });
                reIndicateClassAction();
              }}
              postfix={''}
              prefix={'≤'}
            />
          </Col>
          <Col span={6} className={styles.col}>
            <InputWithSignWheelControl
              label="клоп"
              float
              min={EXTREME_INDICATORS.bug.min}
              max={EXTREME_INDICATORS.bug.max}
              value={String(state.params.clop)}
              onChange={(e) => {
                setState({
                  ...state,
                  params: {
                    ...state.params,
                    clop: processNumberInput(e.target.value),
                  },
                });
                reIndicateClassAction();
              }}
              setValue={(val) => {
                setState({ ...state, params: { ...state.params, clop: +val } });
                reIndicateClassAction();
              }}
              postfix={'%'}
              prefix={'≥'}
            />
          </Col>
          <Col span={6} className={styles.col}>
            <InputWithSignWheelControl
              label="протеин"
              float
              min={EXTREME_INDICATORS.protein.min}
              max={EXTREME_INDICATORS.protein.max}
              value={String(state.params.protein)}
              onChange={(e) => {
                setState({
                  ...state,
                  params: {
                    ...state.params,
                    protein: processNumberInput(e.target.value),
                  },
                });
                reIndicateClassAction();
              }}
              setValue={(val) => {
                setState({ ...state, params: { ...state.params, protein: +val } });
                reIndicateClassAction();
              }}
              postfix={'%'}
              prefix={'≥'}
            />
          </Col>
          <Col span={6} className={styles.col}>
            <InputWithSignWheelControl
              label="число падения"
              min={EXTREME_INDICATORS.cp.min}
              max={EXTREME_INDICATORS.cp.max}
              value={String(state.params.cp)}
              float
              onChange={(e) => {
                setState({
                  ...state,
                  params: {
                    ...state.params,
                    cp: processNumberInput(e.target.value),
                  },
                });
                reIndicateClassAction();
              }}
              setValue={(val) => {
                setState({ ...state, params: { ...state.params, cp: +val } });
                reIndicateClassAction();
              }}
              postfix={'сек'}
              prefix={'≥'}
            />
          </Col>
          <Col span={6} className={styles.col}>
            <InputWithSignWheelControl
              label="натура"
              min={EXTREME_INDICATORS.nature.min}
              max={EXTREME_INDICATORS.nature.max}
              value={String(state.params.nature)}
              float
              onChange={(e) => {
                setState({
                  ...state,
                  params: {
                    ...state.params,
                    nature: processNumberInput(e.target.value),
                  },
                });
                reIndicateClassAction();
              }}
              setValue={(val) => {
                setState({ ...state, params: { ...state.params, nature: +val } });
                reIndicateClassAction();
              }}
              postfix={'г/л'}
              prefix={'≥'}
            />
          </Col>
          <Col span={6} className={styles.col}>
            <InputWithSignWheelControl
              label="влажность"
              min={EXTREME_INDICATORS.humidity.min}
              max={EXTREME_INDICATORS.humidity.max}
              float
              value={String(state.params.humidity)}
              onChange={(e) => {
                setState({
                  ...state,
                  params: {
                    ...state.params,
                    humidity: processNumberInput(e.target.value),
                  },
                });
                reIndicateClassAction();
              }}
              setValue={(val) => {
                setState({ ...state, params: { ...state.params, humidity: +val } });
                reIndicateClassAction();
              }}
              postfix={'%'}
              prefix={'≤'}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};
